import { connect } from 'react-redux'
import { setIpaFlavour } from './Actions.js'
import { fetchData } from './Actions';
import Menu from './Menu'

/*
 * Redux container to wrap Menu component
 */

const mapStateToProps = (state) => {
  const { g2pdata } = state;
  return {
    ipaflavour: g2pdata.ipaflavour,
    saytext: g2pdata.text
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setIpaFlavour: (ipaflavour) => {
      dispatch(setIpaFlavour(ipaflavour))
    },
    fetchData: (word, ipaflavour) => {
      dispatch(fetchData(word, ipaflavour))
    }
  }
}

const MenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Menu)

export default MenuContainer;





// WEBPACK FOOTER //
// ./src/MenuContainer.js